import React from "react";
import Header from "../../Header";
import Footer from "../../components/Footer";
import { Mail, Phone, MapPin, Send } from "lucide-react";

const Contact = () => {
  return (
    <div className="bg-white w-full font-inter">
      <Header />

      {/* ================= HERO ================= */}
      <section className="relative bg-[#FFF0DC] py-24 px-6 md:px-12 text-center overflow-hidden">
        <div className="absolute -top-10 -left-10 w-60 h-60 bg-orange-200 opacity-25 rounded-full blur-3xl"></div>
        <div className="absolute top-20 -right-10 w-72 h-72 bg-orange-300 opacity-20 rounded-full blur-3xl"></div>

        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 relative z-10">
          Contact <span className="text-orange-500">Us</span>
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto mt-4 text-lg">
          We're here to help you. Whether you have questions or need support,
          feel free to reach out — our team responds within 24 hours.
        </p>
      </section>

      {/* ================= CONTACT INFO CARDS ================= */}
      <section className="max-w-7xl mx-auto py-20 px-6 md:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

          {/* Card 1: Email */}
          <div className="bg-white shadow-lg rounded-3xl p-8 text-center hover:shadow-xl transition-all border border-orange-100">
            <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Mail className="text-orange-600 w-7 h-7" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Email Us</h3>
            <p className="text-gray-600 text-sm mb-2">We respond within 24 hours.</p>
            <p className="font-medium text-orange-600">support@quirkle.com</p>
          </div>

          {/* Card 2: Phone */}
          <div className="bg-white shadow-lg rounded-3xl p-8 text-center hover:shadow-xl transition-all border border-orange-100">
            <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Phone className="text-orange-600 w-7 h-7" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Call Us</h3>
            <p className="text-gray-600 text-sm mb-2">Mon - Sat, 9AM - 6PM</p>
            <p className="font-medium text-orange-600">+91 98765 43210</p>
          </div>

          {/* Card 3: Location */}
          <div className="bg-white shadow-lg rounded-3xl p-8 text-center hover:shadow-xl transition-all border border-orange-100">
            <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <MapPin className="text-orange-600 w-7 h-7" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Visit Us</h3>
            <p className="text-gray-600 text-sm mb-2">Our main office</p>
            <p className="font-medium text-orange-600">Mumbai, Maharashtra</p>
          </div>

        </div>
      </section>

      {/* ================= CONTACT FORM ================= */}
      <section className="max-w-6xl mx-auto py-10 px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-16 items-start">

          {/* Left Text */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900">Send Us a Message</h2>
            <p className="text-gray-600 mt-3 text-lg">
              Have any questions or concerns? Let us know — our team is happy to assist you.
            </p>
          </div>

          {/* Form */}
          <form className="bg-white shadow-xl border border-orange-100 rounded-3xl p-10 space-y-6">
            <div>
              <label className="block text-gray-700 font-medium mb-1">Full Name</label>
              <input
                type="text"
                placeholder="Enter your name"
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-300 outline-none"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">Email</label>
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-300 outline-none"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">Message</label>
              <textarea
                rows="4"
                placeholder="Write your message here..."
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-300 outline-none"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all"
            >
              <Send className="w-4 h-4" /> Send Message
            </button>
          </form>

        </div>
      </section>

      {/* ================= GOOGLE MAP ================= */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20">
        <div className="w-full h-72 md:h-96 rounded-3xl overflow-hidden shadow-xl">
          <iframe
            title="Quirkle Location"
            width="100%"
            height="100%"
            loading="lazy"
            allowFullScreen
            src="https://maps.google.com/maps?q=Mumbai&t=&z=13&ie=UTF8&iwloc=&output=embed"
          ></iframe>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
